import * as React from 'react';

import { useClickTracker } from '@shared-ui/clickstream-analytics-context';

import { SearchCriteriaModel } from 'src/common/stores/models';

import { FilterModel, SortAndFilterModel } from './filter-types';

import { UitkExpandoList, UitkExpandoListItem } from 'uitk-react-expando';
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

import { Radios } from './radio-group';

export const RadioGroupExpandoList = ({
  radioGroup,
  handleChange,
  model,
  modelKey,
  sortAndFilterOptions,
  rfrrSuffix,
  isVisible,
}: {
  radioGroup: FilterModel;
  handleChange: (evt) => void;
  model: SearchCriteriaModel;
  modelKey: string;
  sortAndFilterOptions: SortAndFilterModel;
  rfrrSuffix: () => void;
  isVisible: boolean;
}) => {
  const track = useClickTracker();

  return (
    <div data-stid={isVisible ? 'radio-group-expando-list-visible' : 'radio-group-expando-list'}>
      <UitkSpacing margin={{ blockstart: 'two' }}>
        <UitkExpandoList>
          <div className="tnl-collapsing-filter-expando-list">
            <UitkExpandoListItem
              analytics={{
                id: radioGroup.title,
                callback: id => {
                  const idArr = id.split('.');
                  track(`${idArr[0]}.ViewAllFilters.${idArr[1]}`, `${radioGroup.title}.ViewAllFilters`);
                },
              }}
              isVisible={isVisible}
              expandoTitle={
                <UitkHeading size={7} tag="h4">
                  {radioGroup.label}
                </UitkHeading>
              }
              expandoDescription={
                <div className="tnl-collapsing-filter-expando-radio-button">
                  <Radios
                    handleChange={handleChange}
                    model={model}
                    modelKey={modelKey}
                    sortAndFilterOptions={sortAndFilterOptions}
                    rfrrSuffix={rfrrSuffix}
                  />
                </div>
              }
            />
          </div>
        </UitkExpandoList>
      </UitkSpacing>
    </div>
  );
};
